// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1LYHV","name":"ConsentHeader_name__1qMTg","birthday":"ConsentHeader_birthday__3iAk6","skeleton":"ConsentHeader_skeleton__2TJE5"};